module.exports = __webpack_public_path__ + "img/hk_active@3x.f46cda30.png";